<app-slime-background></app-slime-background>

<div class="d-flex align-items-center h-100">
  <div class="container-xl mt-2 mb-5">
    <div class="card">
      <div class="card-body">
        <h1>FAQs - Häufige Fragen zum Ernährungsbegleiter</h1>

        <div class="toc">
          <h2>Inhaltsverzeichnis</h2>
          <a [routerLink]="[]" fragment="wie-funktioniert"
            >Wie funktioniert der Ernährungsbegleiter?</a
          >
          <br />
          <a [routerLink]="[]" fragment="ziel">Was ist das Ziel des Ernährungsbegleiters?</a>
          <br />
          <a [routerLink]="[]" fragment="nutzung">Wie nutze ich den Ernährungsbegleiter?</a>
          <br />
          <a [routerLink]="[]" fragment="kosten">Wie viel kostet der Ernährungsbegleiter?</a>
          <br />
          <a [routerLink]="[]" fragment="datenschutz">Wie melde ich mich als Fachkraft an?</a>
          <br />
          <a [routerLink]="[]" fragment="berateranmelduing">Wie melde ich mich als Fachkraft an?</a>
          <br />
          <a [routerLink]="[]" fragment="dateneingabe">Wie oft soll ich neue Daten eingeben?</a>
          <br />
          <a [routerLink]="[]" fragment="status"
            >Wie wird Dein aktueller Ernährungsstatus berechnet?</a
          >
          <br />
          <a [routerLink]="[]" fragment="ziel-und-ernaehrung">
            Wie wird Dein Ernährungsziel ermittelt und was kann Ernährung bei Krebs bewirken?
          </a>
          <br />
          <a [routerLink]="[]" fragment="gewicht">
            Warum ist ein stabiles Gewicht so wichtig und wie oft sollst Du Dich wiegen?
          </a>
          <br />
          <a [routerLink]="[]" fragment="gewichtsverlauf"
            >Wie wird Dein Gewichtsverlauf ermittelt und bewertet?</a
          >
          <br />
          <a [routerLink]="[]" fragment="beschwerden"
            >Warum ist es wichtig, zu essen, was Deine Beschwerden lindert?</a
          >
          <br />
          <a [routerLink]="[]" fragment="ernaehrungsprobleme"
            >Wie werden Deine Ernährungsprobleme bewertet?</a
          >
          <br />
          <a [routerLink]="[]" fragment="eiweissbedarf">
            Warum ist ausreichend Eiweiß wichtig? Wie berechnen wir Deinen Eiweißbedarf?
          </a>
          <br />
          <a [routerLink]="[]" fragment="ernaehrungstagebuch"
            >Was bringt mir ein Ernährungstagebuch?</a
          >
        </div>

        <br />

        <h2 id="wie-funktioniert">Wie funktioniert der Ernährungsbegleiter?</h2>
        <p>
          Der digitale Ernährungsbegleiter hilft Dir, Deinen Ernährungszustand im Blick zu behalten
          und frühzeitig gegenzusteuern – etwa bei Gewichtsveränderungen, Beschwerden oder drohender
          Mangelernährung
        </p>
        <p>
          Du gibst ein- bis zweimal pro Woche Deine aktuellen Daten ein – z. B. Gewicht, Beschwerden
          und Essensmenge. Daraus wird Deine individuelle Ernährungssituation eingeschätzt: Du
          erhältst sofort eine passende Auswertung mit Empfehlungen zur Linderung von Beschwerden,
          Stabilisierung des Gewichts und Verbesserung Deines Wohlbefindens.
        </p>
        <p>
          Du kannst auch ein Ernährungstagebuch führen, indem Du Deine Mahlzeiten einfach
          fotografierst und mit Notizen versiehst.
        </p>
        <p>
          Und wenn Du möchtest, kannst Du Dich mit einer Fachkraft vernetzen – z. B. mit Deiner
          Ärztin, einem Ernährungsberater oder dem Team von was-essen-bei-krebs.de. Diese Fachkraft
          kann Deine Angaben einsehen und Dich gezielt unterstützen.
        </p>

        <h2 id="ziel">Was ist das Ziel des Ernährungsbegleiters?</h2>
        <p>
          Der digitale Ernährungsbegleiter soll Dir helfen, während Deiner Krebserkrankung gut
          versorgt zu bleiben – mit allem, was Dein Körper jetzt braucht.
        </p>
        <p>
          Das Ziel:<br />
          <strong
            >🟢 Kraft erhalten statt verlieren<br />
            🟢 Beschwerden früh erkennen und gezielt lindern<br />
            🟢 Gewicht und Appetit im Blick behalten<br />
            🟢 Therapien besser durchstehen</strong
          >
        </p>
        <p>
          Dabei wirst Du nicht allein gelassen: Du bekommst alltagstaugliche Empfehlungen –
          automatisch abgestimmt auf Deine Situation. Und wenn Du möchtest, kannst Du Dich mit einer
          Fachkraft vernetzen, die Dich zusätzlich unterstützt.
        </p>

        <h2 id="nutzung">Wie nutze ich den Ernährungsbegleiter?</h2>
        <p>
          Wenn Du noch kein Benutzerkonto hast, beginne mit dem Selbsttest auf unserer Startseite.
          Anschließend kannst Du Dich registrieren und Dein persönliches Konto anlegen. Von dort aus
          begleitet Dich das Programm Schritt für Schritt – mit Auswertungen, Empfehlungen und der
          Möglichkeit, Deine Daten regelmäßig zu aktualisieren.
        </p>

        <p>
          Optional: Mit einer Fachkraft verbinden Wenn Du möchtest, kannst Du Dich mit einer Person
          aus Deinem Behandlungsteam oder einer Ernährungsfachkraft vernetzen – vorausgesetzt, diese
          Person nutzt ebenfalls den Ernährungsbegleiter. Melde Dich dazu in Deinem Konto an und
          gehe im Menü auf “Beratung”. Wenn Du keine Fachkraft vor Ort hast, kannst Du Dich auch mit
          unserem Team von was-essen-bei-krebs.de verbinden – wir helfen Dir gerne weiter.
        </p>

        <h2 id="kosten">Wie viel kostet der Ernährungsbegleiter?</h2>
        <p>Die Nutzung des Ernährungsbegleiters ist für Dich kostenlos.</p>

        <h2 id="datenschutz">Wer hat Zugriff auf meine Daten?</h2>
        <p>
          Deine Daten sind <strong>zunächst nur für Dich sichtbar.</strong> <br />
          Sie werden <strong>nicht automatisch weitergegeben</strong> und dienen ausschließlich
          Deiner <strong>eigenen Einschätzung und Begleitung.</strong>
          <br />
          <br />
          Wenn Du möchtest, kannst Du Dich mit einer <strong>Fachkraft verbinden</strong> – z. B.
          mit einer <strong>Ernährungstherapeutin oder einem Arzt / einer Ärztin.</strong> Erst wenn
          Du die Verbindung <strong>aktiv herstellst und freigibst</strong>, kann diese Person Deine
          Angaben einsehen und Dich gezielt unterstützen.
          <br />
          <br />
          ➡️ <strong>Du entscheidest jederzeit selbst</strong>, ob und mit wem Du Deine Daten
          teilst.
          <br />
          <br />
          💡 Du kannst Dich entweder <strong>bereits während der Registrierung</strong> mit einer
          Fachkraft verbinden oder später – wenn Du eingeloggt bist – unter dem Menüpunkt
          <strong>„Beratung“</strong> eine Fachperson hinzufügen.
        </p>

        <h2 id="berateranmelduing">Wie melde ich mich als Fachkraft an?</h2>
        <p>
          Aktuell befinden wir uns in einer Testphase mit ausgewählten Fachkräften. Wenn Sie
          Interesse daran haben, den digitalen Ernährungsbegleiter in Zukunft mit Ihren
          Patient:innen zusammen zu nutzen, schreiben Sie uns gerne eine E-Mail an:
          <a href="mailto:support@ernaehrungsbegleiter.de" target="_blank"
            >support&#64;ernaehrungsbegleiter.de</a
          >
        </p>

        <h2 id="dateneingabe">Wie oft soll ich neue Daten eingeben?</h2>
        <p>
          Immer wenn Du Dich im Ernährungsbegleiter anmeldest, kannst Du über den Button
          <strong>„aktuelle Daten eingeben“</strong> neue Daten eingeben.
          <br />
          <br />
          Wir empfehlen, <strong>ein- bis zweimal pro Woche</strong> Deine Werte zu aktualisieren.
          <br />
          <br />
          💡 Wenn <strong>neue Beschwerden auftreten</strong> oder sich die Intensität verändert,
          kannst Du natürlich auch <strong>öfter eine Eingabe machen.</strong>
          <br />
          <br />
          Auf Basis Deiner Angaben und ihres Verlaufs berechnen wir Deinen aktuellen
          <strong>Ernährungsstatus</strong> – und Du erhältst eine
          <strong>individuelle Auswertung mit passenden Empfehlungen.</strong>
        </p>

        <h1>Berechnungen und Empfehlungen</h1>
        <h2 id="status">Wie wird Dein aktueller Ernährungsstatus berechnet?</h2>

        <div>
          Dein aktueller Ernährungsstatus zeigt Dir eine kompakte Übersicht zu vier wichtigen
          Bereichen: <br />
          <ul>
            <li>Risiko für eine Mangelernährung</li>
            <li>Dein Körpergewicht</li>
            <li>Deinen Gewichtsverlauf</li>
            <li>Deine Ernährungsprobleme</li>
          </ul>
        </div>

        <p>Diese Bereiche werden wie folgt berechnet und bewertet:</p>
        <div>
          <strong>1. Wie wird Dein Risiko für eine Mangelernährung berechnet?</strong>
          <br />
          <br />
          Um Dein persönliches Mangelernährungsrisiko einzuschätzen kombinieren wir zwei Dinge:
          <br />
          <ul>
            <li>MUST-Score</li>
            <li>Deine Antworten zu den Ernährungsproblemen</li>
          </ul>
        </div>

        <p>
          <strong>Der MUST-Score (Malnutrition Universal Screening Tool):</strong><br />
          Der MUST-Score ist ein international anerkanntes Instrument zur Einschätzung des Risikos
          für Mangelernährung bei Erwachsenen. Drei Bereiche werden bewertet und die Punkte
          zusammengezählt:
        </p>

        <br />

        <div>
          <strong>1. BMI (Body Mass Index) (BMI = Körpergewicht / (Körpergröße)²):</strong><br />
          <ul>
            <li>≥ 20 kg/m² → 0 Punkte<br /></li>
            <li>18,5 – 20 kg/m² → 1 Punkt<br /></li>
            <li>&lt; 18,5 kg/m² → 2 Punkte</li>
          </ul>
        </div>

        <div>
          <strong>2. Ungewollter Gewichtsverlust in den letzten 90 Tagen:</strong><br />
          <ul>
            <li>&lt; 5 % → 0 Punkte<br /></li>
            <li>5 – 10 % → 1 Punkt<br /></li>
            <li>&gt; 10 % → 2 Punkte</li>
          </ul>

          <p>
            Hinweis: Wenn Du <strong>noch nicht seit 90 Tagen angemeldet</strong> bist,
            <strong>schätzen wir den Verlauf</strong>
            auf Basis Deiner Angabe bei der Registrierung (aktuelles Gewicht) und dem von Dir
            angegebenen Gewicht vor drei Monaten.
            <br />
          </p>

          <p>
            Wir gehen dabei von einem <strong>gleichmäßigen Verlauf</strong> aus und berechnen
            daraus den geschätzten Gewichtsverlust. Das liefert eine gute Annäherung, auch wenn noch
            keine Langzeitdaten vorliegen.
            <br />
          </p>
        </div>

        <div>
          <strong>3. Essensmenge der letzten 5 Tage:</strong><br />
          <ul>
            <li>100 – 75 % der üblichen Menge → 0 Punkte<br /></li>
            <li>74 – 50 % → 1 Punkt<br /></li>
            <li>&lt; 50 % → 2 Punkte</li>
          </ul>
        </div>
        <p><strong>Gesamtbewertung MUST-Score</strong> (Summe aller Punkte):</p>

        <div>
          <ul>
            <li>🟢 <strong>0 Punkte:</strong> Kein Risiko<br /></li>
            <li>🟡 <strong>1 Punkt:</strong> Mittleres Risiko<br /></li>
            <li>🔴 <strong>2+ Punkte:</strong> Hohes Risiko</li>
          </ul>
        </div>

        <p>
          <strong>Deine Angaben zu Ernährungsproblemen</strong><br />
          Zusätzlich fließen Deine Antworten auf zwei Fragen ein (jeweils Skala 0–10):<br />
          <br />

          <strong>Frage 1:</strong> Wie stark hast Du im Alltag Ernährungsprobleme?<br />
          <strong>Frage 2:</strong> Wie sehr belasten Dich diese Probleme im Moment?
        </p>

        <div>
          <strong>Bewertung beider Fragen:</strong><br /><br />
          <ul>
            <li>🟢 0 – 3 → 0 Punkte = kein Risiko<br /></li>
            <li>🟡 4 – 6 → 1 Punkt = mittleres Risiko<br /></li>
            <li>🔴 7 – 10 → 2 Punkte = hohes Risiko</li>
          </ul>
        </div>

        <p>
          <strong>Gesamtergebnis: Dein persönliches Risiko</strong><br /><br />
          Am Ende vergleichen wir alle Punkte aus dem <strong>MUST-Score</strong> sowie aus
          <strong>Frage 1</strong> und <strong>Frage 2</strong> zu Deinen Ernährungsproblemen.
          <br />
          <br />
          ➡️ <strong>Der höchste Einzelwert bestimmt Dein Mangelernährungsrisiko.</strong>
        </p>

        <div>
          Diese Bewertung entscheidet über:<br />
          <ul>
            <li>die <strong>Ampelfarbe</strong> 🟢🟡🔴 neben dem Punkt „Mangelernährung“<br /></li>
            <li>
              die <strong>Hintergrundfarbe</strong> der Box „Deine aktuelle Ernährungssituation“
            </li>
          </ul>
        </div>

        <p><strong>Beispiel:</strong></p>
        <div>
          <ul>
            <li>MUST-Score = 0 Punkte<br /></li>
            <li>Frage 1 = 2 Punkte<br /></li>
            <li>Frage 2 = 1 Punkt<br /></li>
            <li>
              → <strong>Gesamtrisiko: 🔴 hoch</strong>, weil der höchste Einzelwert
              <strong>2 Punkte</strong> beträgt.
            </li>
          </ul>
        </div>
        <p>
          <strong>Tipp:</strong> Warum das Thema Mangelernährung sehr wichtig ist, erfährst Du hier:
          <a href="https://www.was-essen-bei-krebs.de/was-essen-bei/mangelernaehrung/"
            >Artikel zum Thema Mangelernährung.</a
          >
        </p>

        <p>
          <strong>2. Wie kommen die “Ampelfarben” für die anderen drei Bereiche zustande?</strong
          ><br />
          Die Ampelfarben 🟢🟡🔴 helfen Dir dabei, Deine Ernährungssituation auf einen Blick
          einzuschätzen.
        </p>

        <p><strong>Bewertung Körpergewicht (BMI):</strong></p>
        <div>
          <p>Wir nutzen hier den <strong>Body Mass Index (BMI):</strong></p>
          <ul>
            <li>🟢 ≥ 20 kg/m²</li>
            <li>🟡 18,5 – 20 kg/m²</li>
            <li>🔴 &lt; 18,5 kg/m²</li>
          </ul>
        </div>

        <p><strong>Bewertung Gewichtsverlauf:</strong></p>
        <div>
          <p>
            Wir berechnen <strong>Deine Gewichtsveränderung in den letzten 30 Tagen</strong> in
            Prozent.
          </p>
          <ul>
            <li>
              Bist Du <strong>länger als 30 Tage angemeldet</strong>, nutzen wir Deine tatsächlichen
              Eingaben.
            </li>
            <li>
              Bist Du <strong>erst kürzer dabei</strong>, berechnen wir einen
              <strong>Schätzwert</strong> basierend auf Deinem Gewicht bei der Registrierung und dem
              Gewicht vor drei Monaten. Dafür ermitteln wir einen <strong>linearen Verlauf</strong>,
              aus dem wir das Gewicht vor 30 Tagen ableiten.
            </li>
          </ul>
        </div>

        <div>
          <p><strong>Ampelfarben:</strong></p>
          <ul>
            <li>🟢 Gewichtsverlust weniger als 0,5 % oder Zunahme</li>
            <li>🟡 Gewichtsverlust zwischen 0,5 % und 5 %</li>
            <li>🟡 Gewichtszunahme mehr als 5 % und BMI über 25 kg/m²</li>
            <li>🔴 Gewichtsverlust mehr als 5 %</li>
          </ul>
        </div>

        <p><strong>Bewertung Ernährungsprobleme:</strong></p>
        <div>
          <p>Wir fragen Dich regelmäßig:</p>
          <ul>
            <li><strong>Wie stark hast Du im Alltag Ernährungsprobleme?</strong></li>
            <li><strong>Wie sehr belasten Dich diese Probleme im Moment?</strong></li>
          </ul>
        </div>

        <div>
          <p>Beide Fragen werden auf einer Skala von 0 bis 10 bewertet.</p>
          <ul>
            <li>🟢 0 – 3</li>
            <li>🟡 4 – 6</li>
            <li>🔴 7 – 10</li>
          </ul>
          <p>Die angezeigte Ampelfarbe entspricht dem höheren der beiden Werte.</p>
        </div>

        <h2 id="ziel-und-ernaehrung">
          Wie wird Dein Ernährungsziel ermittelt und was kann Ernährung bei Krebs bewirken?
        </h2>
        <p>
          Dein Ernährungsziel ergibt sich aus Deinem aktuellen
          <strong>Body Mass Index (BMI).</strong>
          Je nach Bereich fällt die Empfehlung unterschiedlich aus:
        </p>
        <ul>
          <li>
            <strong>BMI unter 17</strong> → Starkes Untergewicht: Gewicht unbedingt stabilisieren
            oder zunehmen; professionelle Unterstützung dringend empfohlen.
          </li>
          <li>
            <strong>BMI 17 – 18,4</strong> → Mäßiges Untergewicht: Gewicht halten oder wenn möglich
            zunehmen; professionelle Unterstützung empfohlen.
          </li>
          <li>
            <strong>BMI 18,5 – 20</strong> → Unterer Normbereich: Gewicht stabil halten oder sanft
            erhöhen.
          </li>
          <li><strong>BMI 20 – 24,9</strong> → Normalgewicht: Gewicht halten.</li>
          <li>
            <strong>BMI über 25</strong> → Übergewicht: Während der Therapie Gewicht halten; keine
            Diät, Fokus auf gute Versorgung.
          </li>
          <li>
            <strong>BMI über 30</strong> → Adipositas: Während der Therapie Gewicht halten; Abnahme
            erst nach Therapie – langsam & begleitet.
          </li>
        </ul>

        <p>
          <strong>Was kann Ernährung bei Krebs bewirken?</strong><br />
          Das Hauptziel der Ernährung bei Krebs ist es, Deinen Körper bestmöglich zu unterstützen:
        </p>
        <ul>
          <li>mit <strong>ausreichend Energie und Nährstoffen</strong></li>
          <li>
            um <strong>Gewichtsverlust</strong> und <strong>Mangelernährung vorzubeugen</strong>
          </li>
          <li>zur <strong>Linderung von Beschwerden</strong></li>
          <li>und zur <strong>Verbesserung Deiner Lebensqualität.</strong></li>
        </ul>

        <p>
          <strong>Wichtig:</strong> Ein bestehender Tumor kann durch Ernährung
          <strong>nicht direkt beeinflusst oder geheilt werden.</strong>
          <br />
          <br />
          Aber: Ernährung kann in <strong>jeder Phase der Erkrankung</strong> dazu beitragen, die
          <strong>Gesamtsituation Deines Körpers zu verbessern</strong> und damit gute
          Voraussetzungen für die
          <strong>Wirkung Deiner medizinischen Therapien schaffen.</strong>
        </p>

        <h2 id="gewicht">
          Warum ist ein stabiles Gewicht so wichtig? Wie oft sollst Du Dich wiegen?
        </h2>
        <p>
          Ein <strong>stabiles Gewicht</strong> ist eine wichtige Voraussetzung dafür, dass Deine
          medizinischen Therapien gut wirken können.
          <strong>Dein Körper braucht jetzt seine ganze Kraft</strong> – und dafür ausreichend
          Energie, Eiweiß und Nährstoffe.
        </p>

        <p><strong>Ungewollter Gewichtsverlust bedeutet:</strong></p>
        <ul>
          <li>Dein Körper bekommt zu wenig Energie</li>
          <li>Es fehlt an Eiweiß und wichtigen Nährstoffen</li>
          <li>Das schwächt Deine Abwehrkräfte, Muskulatur und Heilungsfähigkeit</li>
        </ul>

        <p><strong>Wiege Dich deshalb regelmäßig:</strong></p>
        <ul>
          <li><strong>1–2 Mal pro Woche</strong>, idealerweise</li>
          <li><strong>Morgens, nüchtern, nach dem Toilettengang</strong></li>
          <li>In <strong>leichter Kleidung</strong> (z. B. Unterwäsche)</li>
        </ul>

        <p>
          <strong>Kleine Schwankungen sind normal:</strong><br />
          Sie können z. B. mit dem <strong>Stuhlgang, Fieber, dem Ballaststoffgehalt</strong> Deiner
          Nahrung, der <strong>Außentemperatur</strong> oder dem
          <strong>Wasserhaushalt</strong> zusammenhängen (z. B. Einlagerungen oder
          Flüssigkeitsmangel).
        </p>

        <p>
          <strong>Wichtig:</strong><br />
          Wenn Du <strong>stärkere Wassereinlagerungen</strong> oder
          <strong>Anzeichen von Dehydratation</strong> bemerkst, sprich bitte mit Deiner Ärztin oder
          Deinem Arzt. In diesem Fall sind gewichtsbasierte Empfehlungen möglicherweise nicht
          passend. Dann steht die Linderung Deiner Beschwerden im Vordergrund.
        </p>

        <h2 id="gewichtsverlauf">Wie wird Dein Gewichtsverlauf ermittelt und bewertet?</h2>
        <p>
          Wir berechnen
          <strong>Deine durchschnittliche Gewichtsveränderung in den letzten 30 Tagen</strong> in
          Prozent.
        </p>

        <ul>
          <li>
            Bist Du <strong>länger als 30 Tage angemeldet</strong>, nutzen wir Deine tatsächlichen
            Eingaben.
          </li>
          <li>
            Bist Du <strong>erst kürzer dabei</strong>, berechnen wir einen Schätzwert, basierend
            auf Deinem Gewicht bei der Registrierung und dem Gewicht vor drei Monaten. Dafür
            ermitteln wir einen <strong>linearen Verlauf</strong>, aus dem wir das Gewicht vor 30
            Tagen ableiten.
          </li>
        </ul>

        <p></p>

        <p><strong>Ampelfarben zur Bewertung:</strong></p>
        <ul>
          <li>🟢 Gewichtsverlust weniger als 0,5 % oder Zunahme</li>
          <li>🟡 Gewichtsverlust zwischen 0,5 % und 10 %</li>
          <li>🟡 Gewichtszunahme mehr als 5 % und BMI über 25 kg/m²</li>
          <li>🔴 Gewichtsverlust mehr als 10 %</li>
        </ul>

        <h2 id="beschwerden">Warum ist es wichtig, zu essen, was Deine Beschwerden lindert?</h2>
        <p>
          Während der Erkrankung gilt:<br />
          <strong>Dein Körper gerade braucht und verträgt, ist für Dich gesund.</strong>
        </p>

        <p>
          Was Du essen solltest, hängt ganz von <strong>Deiner aktuellen Situation</strong> ab – und
          die kann sich <strong>immer wieder verändern</strong>. Lass Dich auch davon leiten, worauf
          Du gerade Lust hast und was Dir schmeckt.
        </p>

        <p>
          <strong
            >Ziel ist es, Beschwerden zu lindern und dadurch Gewichtsverlust möglichst zu vermeiden.
          </strong>
        </p>

        <p>
          Manchmal ist das, was Dir gerade <strong>guttut oder Beschwerden lindert</strong>, sogar
          das Gegenteil von dem, was allgemein als „gesund“ gilt.
          <strong>Lass Dich davon nicht verunsichern!</strong> Wichtig ist, dass Du Dich
          <strong>entlastest und ausreichend versorgst</strong>.
        </p>

        <h2 id="ernaehrungsprobleme">Wie werden Deine Ernährungsprobleme bewertet?</h2>
        <p>Wir fragen Dich regelmäßig:</p>
        <ul>
          <li>Wie stark hast Du im Alltag Ernährungsprobleme?</li>
          <li>Wie sehr belasten Dich diese Probleme im Moment?</li>
        </ul>

        <p>Beide Fragen werden auf einer Skala von 0 bis 10 bewertet.</p>

        <ul>
          <li>🟢 0 – 3</li>
          <li>🟡 4 – 6</li>
          <li>🔴 7 – 10</li>
        </ul>

        <p>
          Die <strong>Ampelfarbe</strong> richtet sich nach dem
          <strong>höheren der beiden Werte</strong>. Auch der Auswertungstext passt sich
          entsprechend an.
        </p>

        <p>
          Unter dem Text findest Du
          <strong>Links zu Artikeln mit Empfehlungen zur Linderung der Beschwerden</strong>, deren
          Stärke Du mit <strong>mehr als 0</strong> bewertet hast.
        </p>

        <p>
          Die <strong>stärksten Beschwerden stehen dabei ganz oben</strong> – damit Du gezielt
          Unterstützung findest.
        </p>

        <h2 id="eiweissbedarf">
          Warum ist ausreichend Eiweiß wichtig? Wie berechnen wir Deinen Eiweißbedarf?
        </h2>
        <p>
          Während einer Erkrankung braucht Dein Körper <strong>mehr Eiweiß</strong> – als
          <strong>Baustoff für Muskeln, Immunzellen und Heilungsprozesse</strong>.
        </p>

        <p>
          Ein <strong>Eiweißmangel</strong> kann zu <strong>Muskelabbau</strong> und einem
          <strong>geschwächten Immunsystem</strong> führen.
        </p>

        <p><strong>Wie wurde Dein Eiweißbedarf berechnet?</strong></p>
        <p>
          Laut aktuellen Leitlinien sollten Menschen mit Krebs täglich
          <strong>1,2–1,5 g Eiweiß pro kg Körpergewicht</strong> zu sich nehmen.<br />
          Bei <strong>starken Entzündungen</strong> kann der Bedarf sogar auf bis zu
          <strong>2,0 g/kg</strong> ansteigen.
        </p>

        <p>Zum Vergleich:</p>
        <ul>
          <li>Gesunde Erwachsene: 0,8 g/kg</li>
          <li>Ab 65 Jahren: 1,0 g/kg</li>
          <li>Nach abgeschlossener Krebstherapie gelten ebenfalls die Standardwerte.</li>
        </ul>

        <p>
          <strong>So rechnen wir:</strong><br />
          Wir berechnen, was <strong>1,2–1,5 g Eiweiß pro kg Körpergewicht</strong> für Dich
          bedeutet.
        </p>

        <ul>
          <li>
            <strong>Bei Normalgewicht oder Untergewicht:</strong>
            Die Berechnung basiert auf Deinem tatsächlichen Körpergewicht.
          </li>
          <li>
            <strong>Bei Übergewicht (BMI &gt; 25):</strong>
            Wir verwenden ein <strong>geschätztes Normalgewicht</strong>, berechnet mit der
            <strong>Broca-Formel: Körpergröße in cm – 100.</strong>
          </li>
        </ul>

        <p><strong>Beispiele:</strong></p>

        <p><strong>Person mit Normalgewicht</strong></p>
        <p>65 kg Körpergewicht × 1,2–1,5 g Eiweiß = <strong>78–98 g Eiweiß pro Tag</strong></p>

        <p><strong>Person mit Übergewicht (170 cm groß, 90 kg schwer): </strong></p>
        <p>
          Broca-Gewicht: 170 cm – 100 = 70 kg<br />
          → 70 kg × 1,2–1,5 g = <strong> 84–105 g Eiweiß pro Tag</strong>
        </p>

        <h2 id="ernaehrungstagebuch">Was bringt mir ein Ernährungstagebuch?</h2>
        <p>
          Mit dem digitalen Ernährungstagebuch kannst Du jede Mahlzeit ganz einfach dokumentieren:
          <br />
          Nutze die Buttons, um ein Foto mit Deinem Smartphone aufzunehmen oder eines aus Deiner
          Galerie hochzuladen.
          <br />
          Optional kannst Du kurze Notizen ergänzen – zum Beispiel:
        </p>
        <ul>
          <li>Was hast Du gegessen?</li>
          <li>Wie hast Du Dich nach dem Essen gefühlt?</li>
          <li>Gab es Beschwerden wie Übelkeit, Völlegefühl oder Blähungen?</li>
          <li>Warst Du zufrieden, satt oder noch hungrig?</li>
          <li>
            Wie viel hast Du geschafft?
            <br />
            <small
              >(Tipp: Wenn Du Deinen Teller oft nicht leer essen kannst, fotografiere ihn vor und
              nach dem Essen und füge beide Bilder ins Tagebuch ein – so lässt sich Deine
              Essensmenge gut nachvollziehen.)</small
            >
          </li>
        </ul>
        <p>
          Durch die regelmäßige Dokumentation erkennst Du mit der Zeit Muster.
          <br />
          Was tut Dir gut? Welche Speisen oder Situationen führen zu Problemen? Wann fällt Dir das
          Essen besonders schwer?
          <br />
          <span style="font-size: 1.2em">👉</span>
          Diese Infos helfen Dir, bewusster mit Deiner Ernährung umzugehen – und sie sind eine
          wertvolle Grundlage für Gespräche mit Deinem Behandlungsteam oder einer
          Ernährungsfachkraft. So kann die Unterstützung noch besser auf Deine Situation abgestimmt
          werden.
          <br />
          Auch kleine Fortschritte – wie ein gut verträgliches Frühstück oder eine gelungene
          Zwischenmahlzeit – werden sichtbar und können Dir neue Motivation geben.
          <br />
          <strong>Fazit:</strong><br />
          Ein Ernährungstagebuch unterstützt Dich dabei, Deine Ernährung aktiv zu gestalten,
          Beschwerden besser zu verstehen und Deine Therapie bestmöglich zu begleiten.
        </p>
      </div>
    </div>
  </div>
</div>
